import { BogeyState } from "../../enum/BogeyState";
import { Time } from "../../lib/Time";
import Vector2 from "../../math/Vector2";
import Color from "../../util/Color";
import SPBogey from "../SPBogey";
import SPPlayer from "../SPPlayer";

export default class HomingBogey extends SPBogey {

    hp: number = 1;
    maxHP: number = 1;
    fireRate: number = 0;
    xpReward: number = 2;
    accelerationForce: number = 128;
    color = Color.fromHex("#ff8000");

    AttackUpdate(player: SPPlayer): void {
        if (player.isDead) {
            this.changeState(BogeyState.Wander);
            return;
        }

        if (this.fireRateTimer > 0) {
            this.fireRateTimer -= Time.deltaTime;

            if (this.fireRateTimer <= 0) this.fireRateTimer = 0;
        }

        const targetPos = player.transform.position;
        const diff = this.RotateTowardsPlayer(Math.PI);

        if (Vector2.distance(player.transform.position, this.transform.position) <= 256 && diff <= 0.1745) {
            this.ShootAt(player.transform);
        }
        this.acceleration = Vector2.zero;
        this.velocity = targetPos.sub(this.transform.position).normalized.scale(this.accelerationForce);
    }

}